module.exports = __webpack_public_path__ + "static/media/sidebarnoticeboard.24ddf89c.png";